import { logger, stats, LOG_LEVELS, LogLevel, LogEntity } from '@fiverr-private/obs';
import { MetricValue } from '@fiverr-private/obs/src/stats/types';
import { config } from './configuration';

export { LOG_LEVELS };

export const count = (metric: string) => stats.count(`services.${config.appName}.rollout.clients.js`, metric);

export const time = (metric: string, value: MetricValue) =>
    stats.time(`services.${config.appName}.rollout.clients.js`, metric, value);

export const countDistribution = (rolloutName: string, inRollout: boolean) =>
    stats.count(`services.${config.appName}.rollout.distributions`, `${rolloutName}.${inRollout}`);

export const log = (level: LogLevel, logEntity: LogEntity, enrichment = {}): void => {
    logger[level](logEntity, { source: 'rollout_package', client: 'JS', ...enrichment });
};
